module.exports = __webpack_public_path__ + "img/05.971075e5.png";